import React from "react";
import { useNavigate } from "react-router-dom";
import CreateAssignment from "./CreateAssignment";
import ViewAssignment from "./ViewAssignment";
import Holidays from "./Holidays";
import PTO from "./PTO";

export default function RequestPool() {
  return <ViewAssignment />;
}

export function ManualAssignmentPage() {
  return <CreateAssignment />;
}

export function RequestLeavePage() {
  return <PTO />;
}

export function HolidaysPage() {
  const navigate = useNavigate();
  return <Holidays onBack={() => navigate("/manage")} />;
}
